// @flow
import * as React from 'react'
import uuid from 'uuid/v1'
import ReactTooltip from 'react-tooltip'

import './Tooltip.scss'

export type Props = {
  callToAction?: string | React.Node,
  children: React.Node,
  title?: string,
  ctaColor: 'primary' | 'secondary',
  useDiv?: boolean,
}

export default class Tooltip extends React.Component<Props> {
  id: string

  static defaultProps = {
    ctaColor: 'primary',
  }

  constructor() {
    super()
    this.id = uuid()
  }

  render = () => {
    const linkProps = {
      className: this.props.useDiv ? '' : 'Tooltip',
      'data-effect': 'solid',
      'data-event': this.props.useDiv ? 'mouseover' : 'click focus',
      'data-for': this.id,
      'data-tip': true,
      'data-type': 'light',
    }
    return (
      <React.Fragment>
        {this.props.useDiv ? (
          <div {...linkProps}>{this.renderCta()}</div>
        ) : (
          <a {...linkProps}>{this.renderCta()}</a>
        )}
        <ReactTooltip
          className="Tooltip-balloonWrapper"
          globalEventOff="click"
          id={this.id}
          overridePosition={({ left, top }, _triggerElement, _tooltip, _node) => {
            return {
              top: Math.max(top, 20),
              left: Math.max(left, 0),
            }
          }}
        >
          <div className="Tooltip-balloon">
            {this.props.title && <div className="Tooltip-title">{this.props.title}</div>}
            <div className="Tooltip-content">{this.props.children}</div>
          </div>
        </ReactTooltip>
      </React.Fragment>
    )
  }

  renderCta = () => {
    if (this.props.callToAction) return this.props.callToAction

    return (
      <div className={`Tooltip-ctaWrapper Tooltip-ctaWrapper--${this.props.ctaColor}`}>
        <span className="Tooltip-cta">?</span>
      </div>
    )
  }
}
